import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface DocumentIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function DocumentIcon({ className, color = 'white', ...props }: DocumentIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2.875 18.9995V5C2.875 2.72183 4.72183 0.875 7 0.875H13.5859C13.8793 0.875021 14.1656 0.937818 14.4297 1.05225C14.437 1.05527 14.4444 1.05786 14.4517 1.06104C14.6234 1.13771 14.7852 1.23649 14.9321 1.35693L15.0889 1.49756L20.5029 6.91162C20.6831 7.09187 20.825 7.30246 20.9292 7.52979C20.9364 7.54545 20.9446 7.56062 20.9512 7.57666C21.0638 7.839 21.1255 8.12354 21.1255 8.41455V18.9995C21.1255 21.2775 19.2784 23.1242 17.0005 23.1245H7C4.72183 23.1245 2.875 21.2777 2.875 18.9995ZM15.1255 6.00049C15.1257 6.48352 15.5169 6.875 16 6.875H17.2847L15.1255 4.71582V6.00049ZM5.125 18.9995C5.125 20.035 5.96447 20.8745 7 20.8745H17.0005C18.0358 20.8742 18.8755 20.0349 18.8755 18.9995V9.125H16C14.2743 9.125 12.8757 7.72616 12.8755 6.00049V3.125H7C5.96447 3.125 5.125 3.96447 5.125 5V18.9995Z"
        fill={color}
      />
      <path
        d="M12.9995 15.8755L13.1152 15.8813C13.6824 15.9391 14.1245 16.4181 14.1245 17.0005C14.1243 17.5827 13.6823 18.062 13.1152 18.1196L12.9995 18.1255H8C7.37884 18.1255 6.87526 17.6216 6.875 17.0005C6.875 16.3792 7.37868 15.8755 8 15.8755H12.9995ZM15.9995 11.875L16.1152 11.8809C16.6824 11.9386 17.1245 12.4176 17.1245 13C17.1245 13.5824 16.6824 14.0614 16.1152 14.1191L15.9995 14.125H8C7.37868 14.125 6.875 13.6213 6.875 13C6.875 12.3787 7.37868 11.875 8 11.875H15.9995Z"
        fill={color}
      />
    </svg>
  );
}
